<template>
  <div class="gradient-blobs opacity-30">
    <div class="blob blob-1"></div>
    <div class="blob blob-2"></div>
    <div class="blob blob-3"></div>
    <div class="gradient-overlay"></div>
  </div>
</template>

<style scoped>
.gradient-blobs {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.5;
}

.blob-1 {
  width: max(40vw, 800px);
  aspect-ratio: 1/1;
  left: -10vw;
  bottom: -40vw;
  background: rgb(0, 242, 255);
  animation: moveBlob3 8s infinite linear alternate;
}

.blob-2 {
  width: max(50vw, 800px);
  aspect-ratio: 1/1;
  right: -5vw;
  bottom: -45vw;
  background: rgb(99, 161, 255);
  animation: moveBlob2 9s infinite linear alternate;
}

.blob-3 {
  width: max(45vw, 800px);
  aspect-ratio: 1/1;
  left: 0;
  bottom: -40vw;
  background: rgb(173, 255, 30);
  animation: moveBlob1 10s infinite linear alternate;
}

.gradient-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom right,
    rgba(255, 255, 255, 0.2),
    rgba(255, 255, 255, 0.1)
  );
}

@keyframes move {
  0% {
    transform: translate(0, 0) rotate(0deg) scale(1);
  }
  33% {
    transform: translate(30px, -50px) rotate(120deg) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) rotate(240deg) scale(0.9);
  }
  100% {
    transform: translate(0, 0) rotate(360deg) scale(1);
  }
}

@keyframes moveBlob1 {
  0% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(300px, 100px) scale(1.2);
  }
  66% {
    transform: translate(200px, 100px) scale(1.2);
  }
  100% {
    transform: translate(0, 0) scale(1);
  }
}

@keyframes moveBlob2 {
  0% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(100px, -150px) scale(1.2);
  }
  66% {
    transform: translate(250px, -200px) scale(1.2);
  }
  100% {
    transform: translate(0, 0) scale(1);
  }
}

@keyframes moveBlob3 {
  0% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(-200px, 100px) scale(1.2);
  }
  66% {
    transform: translate(-100px, 100px) scale(1.2);
  }
  100% {
    transform: translate(0, 0) scale(1);
  }
}
</style>


